module.exports = __webpack_public_path__ + "img/b4e1f417affa586773a5e18048d96717.png";